(function() {
  var testimonialsSlider = function() {
    $('.testimonials-block').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000
    });
  };
  var imagetextSlider = function() {
    $('.image-with-text-slider').slick({  
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev image-text-prev"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow_5f728dfb-e1b2-4b33-bb0e-b9f7c18f95db.svg?v=1653560592" /></button>',
      nextArrow: '<button type="button" class="slick-next image-text-next"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow_5f728dfb-e1b2-4b33-bb0e-b9f7c18f95db.svg?v=1653560592" /></button>',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  };
  var textImageSlider = function(){
    $('.text-image-block').slick({  
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  };
  var productSlider = function(){
    
    if($('.product-grid-slider-block').length == 0){
      setTimeout(function(){
        productSlider();
      },2000);
      return;
    }
    $('.product-grid-slider-block').slick({  
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            nav: false
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            nav: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            nav: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev image-text-prev"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>',
            nextArrow: '<button type="button" class="slick-next image-text-next"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>'
          }
        }
      ]
    });
  };

  //console.log("testing");
  const changeSlicklSlide = () => {
        console.log('Owl Changed')
    $('.product-grid-slider-block').find('.product-grid-slider-block-item').removeClass('logo-slide-center logo-slide-left logo-slide-right');
    $('.product-grid-slider-block').find('.product-grid-slider-block-item.slick-current.slick-active').addClass('logo-slide-center');
    $('.product-grid-slider-block').find('.product-grid-slider-block-item.slick-current.slick-active').prev().addClass('logo-slide-left');
    $('.product-grid-slider-block').find('.product-grid-slider-block-item.slick-current.slick-active').next().addClass('logo-slide-right');
  }

  $(document).ready(function(){
      changeSlickSlide();
  });
  
  var productSliderNew = function(){
    $('.product-grid-slider-block-new').slick({  
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            nav: false
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            nav: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            nav: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev image-text-prev"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>',
            nextArrow: '<button type="button" class="slick-next image-text-next"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>'
          }
        }
      ]
    });
  };
  
  var productPageSlider = function(){
    $('.product__media-list').slick({  
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="slick-prev image-text-prev"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>',
      nextArrow: '<button type="button" class="slick-next image-text-next"><img src="https://cdn.shopify.com/s/files/1/0299/2046/0884/files/right-arrow-new.svg?v=1653567046" /></button>'
    });
  };

  var locationsTabs = function(){
    $(document).on('click','.location-block-section .location-header-section .header-location-tab-block .location-head-title', function(){
      $('.location-block-section .location-header-section .header-location-tab-block .location-tab-group').toggle();
    });
    $(document).on('click', '.location-block-section .location-header-section .header-location-tab-block .header-location-tab h2', function(){
      $('.location-block-section .location-header-section .header-location-tab-block .header-location-tab').removeClass('active');
      $('.product-location-map-lists .locations-block-section').removeClass('active');
      var currentId = $(this).data('location-title');
      $(this).parent().addClass('active');
      var currentText = $(this).text();
      $('.location-block-section .location-header-section .header-location-tab-block .location-head-title span').text(currentText);
      $('.product-location-map-lists .locations-block-section[data-location-content="'+currentId+'"]').addClass('active');
      $('.location-block-section .location-header-section .header-location-tab-block .location-tab-group').hide();
      
      // updating URL on city change code
      let currentCity = this.innerText;
      currentCity = currentCity.trim();
      currentCity = currentCity.toLowerCase();
      document.querySelectorAll('.header-location-tab').forEach(function(ele){
        let city = ele.innerText;
        city = city.trim();
        city = city.toLowerCase();
      });
      let currentURL = window.location.href;
      if(currentURL.includes('city=')){
        let splitCurrentURL = currentURL.split('?city=')
        let newURL = splitCurrentURL[0]+'?city='+currentCity;
        window.history.pushState("object or string", "Location", newURL);
      }else{
        let newURL = currentURL+'?city='+currentCity;
        window.history.pushState("object or string", "Location", newURL);
      }
      // updating URL on city change code ends
      
    });
  };

  testimonialsSlider();
  imagetextSlider();
  productSlider();
  productSliderNew();
  productPageSlider();
  locationsTabs();
  if($(window).width() < 767){
    textImageSlider();
  }
  $(document).on('shopify:section:load', function(event) {
    testimonialsSlider();
    imagetextSlider();
    textImageSlider();
    productSlider();
    productSliderNew();
    productPageSlider();
    locationsTabs();
  });
}());
$('.et-custom_property').on('click', function() {
  var ground = $(this).data('option');
  $('.et-custom_property').removeClass('active');
  $(this).addClass('active');
  $('input[name="properties[Ground]"]').val(ground);
});  
  
document.addEventListener('DOMContentLoaded', function(){
    // updating URL on page load
    let currentURL = window.location.href;
    if(currentURL.includes('/pages/location')){
      if(currentURL.includes('city=')){
        let splitCurrentURL = currentURL.split('?city=')
        let currentCity = splitCurrentURL[1];
        document.querySelectorAll('.header-location-tab').forEach(function(ele, ind){
          ele.classList.remove('active');
          let city = ele.innerText;
          city = city.trim();
          city = city.toLowerCase();
          if(city == currentCity){
            ele.classList.add('active');
            document.querySelector('.header-location-tab-block .location-head-title span').innerText = city;
            let dataLocationTitle = ele.querySelector('h2').getAttribute('data-location-title');
            document.querySelectorAll('.locations-block-section').forEach(function(ele){
              ele.classList.remove('active');
              let dataLocationContent = ele.getAttribute('data-location-content');
              if(dataLocationContent == dataLocationTitle){
                ele.classList.add('active');
              }
            });
            document.querySelector('.location-block-section').style.display = 'block';
          }
        });
      }else{
        let newURLonLoad = currentURL+'?city=barcelona';
        window.history.pushState("object or string", "Location", newURLonLoad);
      } 
    }
    // updating URL on page load ends
}, false);



